import { AppConstants } from "../../../../core/constants/constants";
import { NotificationSocketRepository } from "../../domain/repositories/NotificationSocketRepository";
import { NotificationSocketDataSource } from "../datasource/NotificationSocketDataSource";

export class NotificationRepositorySocketImpl implements NotificationSocketRepository {
	constructor(private dataSource: NotificationSocketDataSource) {}

	connectSocket(): Promise<void> {
		return AppConstants.getRightOrLeftSide<void>(
			this.dataSource.connectSocket()
		);
	}

	disconnectSocket(): Promise<void> {
		return AppConstants.getRightOrLeftSide<void>(
			this.dataSource.disconnectSocket()
		);
	}

	onPurchaseMessageNotification(
		callback: (data: number) => void
	): void {
		this.dataSource.onPurchaseMessageNotification(callback);
	}
}
